import React, { useState, useEffect, useRef, ComponentState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "@progress/kendo-react-tooltip";
import { getCarePlanReSignNotifications } from "../../redux/actions";
import { Link } from "react-router-dom";
import { Card, CardBody } from "@progress/kendo-react-layout";
import { useNavigate } from "react-router-dom";

interface TreatmentPlan {
    planName: string;
    clientId: number;
    clinicId: number;
    id: number;
    treatmentPlanId: number;
    viewed: number;
}
const CarePlanResignNotification: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [plans, setPlans] = useState<TreatmentPlan[]>([]);
    const [showList, setShowList] = useState<boolean>(false);
    const anchor = useRef<HTMLDivElement | null>(null);
    const popoverRef = useRef<HTMLDivElement | null>(null);
    const state: ComponentState = useSelector((states) => {
        return states;
    });
    const { carePlanReSignNotificationList } = state["ClientReducer"];
    useEffect(() => {
        setPlans(carePlanReSignNotificationList)
    }, [carePlanReSignNotificationList])

    useEffect(() => {
        dispatch(getCarePlanReSignNotifications());
    }, [dispatch]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;
            if (
                showList &&
                anchor.current &&
                popoverRef.current &&
                !anchor.current.contains(target) &&
                !popoverRef.current.contains(target)
            ) {
                setShowList(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showList]);

    const handleBellClick = () => {
        setShowList(!showList);
    };
    const handleCardClick = (plan: TreatmentPlan) => {
        setShowList(false);
        navigate("/care-plan", { state: { tpPlanId: plan.treatmentPlanId } });
    };


    return (
        <div className="notification-wrapper" style={{ position: "relative" }}>
            <div
                ref={anchor}
                className="icon-container"
                id="bell-icon"
                onClick={handleBellClick}
                style={{ cursor: "pointer" }}>
                <i className="fa fa-bell" aria-hidden="true"></i>
                {plans.length > 0 && <span className="badge">{plans.length}</span>}
            </div>
            {anchor.current && showList && (
                <Popover
                    show={showList}
                    anchor={anchor.current}
                    position="bottom"
                    collision={{ horizontal: "fit", vertical: "flip" }}
                    className="custom-popover"
                    style={{ width: 275 }}>
                    <div ref={popoverRef}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "5px" }} onClick={handleBellClick}>
                            {plans.map((plan) => (
                                <Card
                                    key={plan.id}
                                    style={{ borderLeft: "4px solid #048373", cursor: "pointer" }}
                                    className="mb-1"
                                    onClick={() => handleCardClick(plan)}>
                                    <CardBody>
                                        Treatment plan <strong>{plan.planName}</strong> requires your signature.
                                    </CardBody>
                                </Card>
                            ))}
                        </div>
                    </div>
                </Popover>
            )}
        </div>
    );
};

export default CarePlanResignNotification;
